import React from 'react';

const FILTERS = [
  { id: 'all',              label: 'All' },
  { id: 'queued',           label: 'Queued' },
  { id: 'setup',            label: 'Setup' },
  { id: 'customization',    label: 'Customization' },
  { id: 'awaiting_delivery','label': 'Awaiting Delivery' },
  { id: 'delivery',         label: 'Delivery' },
  { id: 'deployed',         label: 'Deployed' },
];

const BuildFilterBar = ({ activeFilter, onChange, counts = {} }) => (
  <div className="flex items-center gap-2 flex-wrap">
    {FILTERS.map(f => {
      const count = f.id === 'all'
        ? Object.values(counts).reduce((a, b) => a + b, 0)
        : (counts[f.id] || 0);
      const active = activeFilter === f.id;
      return (
        <button
          key={f.id}
          onClick={() => onChange(f.id)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-data font-bold transition-colors ${
            active
              ? 'bg-[#7B61FF] text-white'
              : 'bg-[#F0EFF4]/10 text-[#F0EFF4]/60 hover:bg-[#F0EFF4]/15 hover:text-[#F0EFF4]'
          }`}
        >
          {f.label}
          {count > 0 && (
            <span className={`px-1.5 py-0.5 rounded-full text-[10px] leading-none ${
              active ? 'bg-white/20 text-white' : 'bg-[#F0EFF4]/10 text-[#F0EFF4]/40'
            }`}>
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default BuildFilterBar;
